import { default as app } from '../vuex';
import { default as auth } from '../auth/vuex';
import { default as application } from '../application/vuex';

export default {
	app,
	auth,
	application
};
